@if (product | async; as product) {
    <div class="p-0 lg:p-16 pt-[8.5rem] lg:pt-52">
        <div class="grid lg:grid-cols-2 relative mb-5 md:mb-0">
            <div class="lg:px-14 lg:pb-14 min-w-0">
                <!--breadcrumb-->
                <nav class="w-full rounded-md py-3 px-5 lg:px-0 text-sm lg:text-base">
                    <div class="list-reset flex items-center whitespace-nowrap overflow-hidden">
                        @for (link of links; track link) {
                            <div class="shrink-0">
                                <app-link [link]="link"/>
                            </div>
                            <div class="shrink-0">
                                <span class="mx-1.5 lg:mx-2 text-neutral-400">/</span>
                            </div>
                        }
                        <div class="text-neutral-400 truncate min-w-0">{{ product.name }}</div>
                    </div>
                </nav>
                <div id="order-dialog-carousel"
                     class="relative my-auto"
                     data-te-carousel-init>
                    <!--Carousel items-->
                    <div class="relative w-full overflow-hidden after:clear-both after:block after:content-['']">
                        <!--First item-->
                        <div class="relative float-left -mr-[100%] w-full transition-transform duration-[600ms] ease-in-out motion-reduce:transition-none"
                             data-te-carousel-item
                             data-te-carousel-active>
                            <app-image
                                    [src]="product.images[0]"
                                    class="block mx-auto w-auto max-w-full max-h-[32vh] lg:max-h-none lg:w-full object-contain"
                                    [alt]="product.altImages[0]"/>
                        </div>
                        @for (image of product?.images; track image; ) {
                            @if ($index !== 0) {
                                <div class="relative float-left -mr-[100%] hidden w-full transition-transform duration-[600ms] ease-in-out motion-reduce:transition-none"
                                     data-te-carousel-item>
                                    <app-image
                                            [src]="product.images[$index]"
                                            class="block mx-auto w-auto max-w-full max-h-[32vh] lg:max-h-none lg:w-full object-contain"
                                            [alt]="product.altImages[$index]"/>
                                </div>
                            }
                        }
                    </div>

                    @if (product.images.length > 1) {
                        <!--Carousel controls - prev item-->
                        <button
                                class="absolute bottom-0 left-0 top-0 z-[1] flex w-[15%] items-center justify-center border-0 bg-none p-0 text-center text-black opacity-50 transition-opacity duration-150 ease-[cubic-bezier(0.25,0.1,0.25,1.0)] hover:text-black hover:no-underline hover:opacity-90 hover:outline-none focus:text-black focus:no-underline focus:opacity-90 focus:outline-none motion-reduce:transition-none"
                                type="button"
                                data-te-target="#order-dialog-carousel"
                                data-te-slide="prev">
    <span class="inline-block h-8 w-8">
      <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="h-6 w-6">
        <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 19.5L8.25 12l7.5-7.5"/>
      </svg>
    </span>
                            <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
                            >Previous</span>
                        </button>
                        <!--Carousel controls - next item-->
                        <button class="absolute bottom-0 right-0 top-0 z-[1] flex w-[15%] items-center justify-center border-0 bg-none p-0 text-center text-black opacity-50 transition-opacity duration-150 ease-[cubic-bezier(0.25,0.1,0.25,1.0)] hover:text-black hover:no-underline hover:opacity-90 hover:outline-none focus:text-black focus:no-underline focus:opacity-90 focus:outline-none motion-reduce:transition-none"
                                type="button"
                                data-te-target="#order-dialog-carousel"
                                data-te-slide="next">
    <span class="inline-block h-8 w-8">
      <svg xmlns="http://www.w3.org/2000/svg"
           fill="none"
           viewBox="0 0 24 24"
           stroke-width="1.5"
           stroke="currentColor"
           class="h-6 w-6">
        <path stroke-linecap="round"
              stroke-linejoin="round"
              d="M8.25 4.5l7.5 7.5-7.5 7.5"/>
      </svg>
    </span>
                            <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
                            >Next</span>
                        </button>
                    }
                </div>
            </div>
            <form [formGroup]="orderItemControl" class="pt-3 lg:pt-8 px-5 lg:px-10 relative">
                @if (product && product.category) {
                    <app-text [class]="'text-2xl lg:text-4xl  font-medium text-left'"
                              [isTitle]="true"
                              [value]="product.name"></app-text>
                }
                @if (reviews && reviews.count > 0) {
                    <!-- A button, not href="#reviews": with <base href="/"> that link would go to the home page. -->
                    <button type="button" class="flex items-center gap-2 pt-1 text-sm text-gray-700 hover:underline"
                            (click)="scrollToReviews()">
                        <app-star-rating [rating]="reviews.average"></app-star-rating>
                        <span>{{ formatRating(reviews.average) }} · {{ reviewCountLabel(reviews.count) }}</span>
                    </button>
                }
                <hr class="h-px my-1 bg-gray-400 border-0">
                <div class="flex text-xl lg:text-2xl text-left">
                    <app-text
                            [ngClass]="product?.discount? 'text-red-600': ''"
                            [value]="(product?.price! * (quantityControl.value ?? 0)) + ' ден.'"></app-text>
                    @if (product?.discount) {
                        <app-text class="line-through px-1.5"
                                  [value]="(product?.originalPrice! * (quantityControl.value ?? 0)) + ' ден.'"></app-text>
                    }
                </div>
                <!-- Phones: price, quantity and both buttons fit on the first screen; the reassurance comes right after. -->
                <div class="mt-3 lg:mt-10">
                    <div class="pb-3 lg:pb-10 flex justify-start">
                        <app-quantity-selector
                                [control]="quantityControl"
                                [placeholder]="'Количина'"></app-quantity-selector>
                    </div>
                    <div class="pt-1 lg:pt-14" #mainBuyButtons>
                        <app-secondary-button
                                class="flex justify-center items-center"
                                value="Додади во кошничка"
                                (click)="addToCart()"></app-secondary-button>
                        <app-primary-button
                                class="pt-3 pb-5 flex justify-center items-center"
                                value="Купи сега"
                                (click)="buyNow()"></app-primary-button>
                    </div>
                <ul class="list-none pl-0 mt-0 mb-4 space-y-1 text-left">
                    @for (point of trustPoints(product); track point) {
                        <li class="flex items-start gap-2 text-sm lg:text-base text-gray-700">
                            <span class="text-green-600 font-bold" aria-hidden="true">✓</span>
                            <span>{{ point }}</span>
                        </li>
                    }
                </ul>
                    <app-bought-together [product]="product" (added)="openCartOverview()"></app-bought-together>
                    @if (product.disclaimer) {
                        <app-text [class]="'text-sm lg:text-lg pt-3 lg:pt-5 text-left text-red-500'"
                                  [value]="product?.disclaimer"></app-text>
                    }
                    @if (product.content) {
                        <div [innerHTML]="product.content"></div>
                    } @else {
                        <app-text [class]="'text-sm lg:text-lg pt-3 lg:pt-5 text-left'"
                                  [value]="product?.description"></app-text>
                    }
                    @if (generatedFaq.length > 0) {
                        <section class="pt-6 text-left">
                            <h2 class="font-medium pb-2">Чести прашања</h2>
                            @for (entry of generatedFaq; track entry.question) {
                                <h3 class="font-medium pt-3">{{ entry.question }}</h3>
                                <p class="text-sm lg:text-base text-gray-700">{{ entry.answer }}</p>
                            }
                        </section>
                    }
                    <div class="pt-7 lg:pt-14">
                        <app-secondary-button
                                class="flex justify-center items-center"
                                value="Додади во кошничка"
                                (click)="addToCart()"></app-secondary-button>
                        <app-primary-button
                                class="pt-3 pb-5 flex justify-center items-center"
                                value="Купи сега"
                                (click)="buyNow()"></app-primary-button>
                    </div>
                </div>
            </form>
            <app-toast [message]="toastMessage"></app-toast>
        </div>
    </div>
    <app-product-reviews [productId]="product.id!" [summary]="reviews"></app-product-reviews>
    @if (products.length > 0) {
        <app-related-products [relatedProducts]="products"></app-related-products>
    } @else {
        <app-related-products [product]="product"></app-related-products>
    }
    <app-footer></app-footer>
    <!-- room for the sticky buy bar, so it never covers the end of the footer -->
    <div class="h-20 lg:hidden" aria-hidden="true"></div>

    @if (showStickyBuy) {
        <div class="fixed bottom-0 inset-x-0 z-40 lg:hidden bg-white border-t border-gray-200 shadow-[0_-4px_12px_rgba(0,0,0,0.08)] px-4 py-3 flex items-center gap-3">
            <div class="min-w-0 flex-1 text-left">
                <p class="truncate text-xs text-gray-600">{{ product.name }}</p>
                <p class="text-lg font-medium text-gray-900">{{ product.price * (quantityControl.value || 1) }} ден.</p>
            </div>
            <button type="button"
                    class="shrink-0 bg-primaryDark text-white rounded px-6 py-3 font-medium hover:bg-primaryDarker transition"
                    (click)="buyNow()">Купи сега</button>
        </div>
    }
}
